import { render, staticRenderFns } from "./Xbcsjkquery.vue?vue&type=template&id=b170b348&scoped=true"
import script from "./Xbcsjkquery.vue?vue&type=script&lang=js"
export * from "./Xbcsjkquery.vue?vue&type=script&lang=js"
import style0 from "./Xbcsjkquery.vue?vue&type=style&index=0&id=b170b348&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b170b348",
  null
  
)

export default component.exports